import type { RaceEventIconView } from '../views/RaceEventIconView';
import type { MetaPopupController } from '../../../metaAbstractions/types';
import { RaceEventRankChangePopup } from '../views/RaceEventRankChangePopup';

interface RankChangeConfig {
  popups: MetaPopupController;
  iconView: RaceEventIconView;
  previousRank: number;
  currentRank: number;
}

export async function showIconRankChange(config: RankChangeConfig): Promise<void> {
  const { previousRank, currentRank, popups, iconView } = config;

  const popup = new RaceEventRankChangePopup(previousRank, currentRank);

  void popups.addPopup(popup);

  // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
  const { promise, resolve } = Promise.withResolvers<void>();

  popup.onReadyForFlagTransfer.connect(async (flagContainer) => {
    await iconView.acceptFlagContainer(flagContainer);
    await popups.closeActivePopup();
    resolve();
  });

  return promise;
}
